// Widget configuration + editable copy strings. The host page sets `apiBase`
// (where the chat service lives) via a data attribute or a global; everything
// else has an on-brand default that an integrator can override.

export interface WidgetConfig {
  apiBase: string;
  launcherLabel: string;
  title: string;
  greeting: string;
  placeholder: string;
  consent: string;
  /** One-tap starter questions shown under the greeting (kills the blank-page problem). */
  openerChips: string[];
  /** Bot reply when the "look at my website" starter chip is tapped (asks for the URL). */
  teaserReply: string;
}

export const DEFAULT_COPY: Omit<WidgetConfig, 'apiBase'> = {
  launcherLabel: 'Ask MarginArc',
  title: 'MarginArc assistant',
  greeting:
    "Hi, I'm the MarginArc assistant. I can show you where AI tends to pay first in a distribution back office, or get you a rough number. What do you distribute?",
  placeholder: 'Ask anything, or paste your website',
  openerChips: [
    'Where would AI pay first for me?',
    "What's this costing me by hand?",
    'Look at my website for me',
    'What do you actually do?',
  ],
  // Shown when the "look at my website" chip is tapped — we ask for the URL client-side
  // (the website read only fires once the server sees an actual address in the message).
  teaserReply:
    "Sure. Paste your website address (like yourcompany.com) and I'll take a quick look at where AI might pay for you.",
  consent:
    'You are chatting with an AI assistant. Conversations may be stored for quality and follow-up. Please do not share sensitive information.',
};

export function resolveConfig(overrides: Partial<WidgetConfig> & { apiBase: string }): WidgetConfig {
  return { ...DEFAULT_COPY, ...overrides };
}
